<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 417 417"
    class="svg-icon"
    style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"
  >
    <path
      d="M208.333,0c114.983,0 208.334,93.351 208.334,208.333c-0,114.983 -93.351,208.334 -208.334,208.334c-114.982,-0 -208.333,-93.351 -208.333,-208.334c-0,-114.982 93.351,-208.333 208.333,-208.333Zm-25.311,208.333l-53.493,-53.493c-3.322,-3.322 -5.189,-7.829 -5.189,-12.528c-0,-4.698 1.867,-9.205 5.189,-12.527c0.085,-0.086 0.17,-0.171 0.256,-0.256c3.322,-3.322 7.829,-5.189 12.527,-5.189c4.699,-0 9.206,1.867 12.528,5.189l53.493,53.493l53.493,-53.493c3.323,-3.322 7.829,-5.189 12.528,-5.189c4.699,-0 9.205,1.867 12.528,5.189c0.085,0.085 0.17,0.17 0.255,0.256c3.323,3.322 5.19,7.829 5.19,12.527c-0,4.699 -1.867,9.206 -5.19,12.528l-53.492,53.493l53.492,53.493c3.323,3.323 5.19,7.829 5.19,12.528c-0,4.699 -1.867,9.205 -5.19,12.528c-0.085,0.085 -0.17,0.17 -0.255,0.255c-3.323,3.323 -7.829,5.19 -12.528,5.19c-4.699,-0 -9.205,-1.867 -12.528,-5.19l-53.493,-53.492l-53.493,53.492c-3.322,3.323 -7.829,5.19 -12.528,5.19c-4.698,-0 -9.205,-1.867 -12.527,-5.19c-0.086,-0.085 -0.171,-0.17 -0.256,-0.255c-3.322,-3.323 -5.189,-7.829 -5.189,-12.528c-0,-4.699 1.867,-9.205 5.189,-12.528l53.493,-53.493Z"
    />
  </svg>
</template>

<script>
export default {
  name: "IconReject"
};
</script>
